{% block swag_cms_extensions_form_template_create_modal %}
    <mt-modal-root
        :is-open="true"
        @change="onModalClose"
    >
        <mt-modal
            class="swag-cms-extensions-form-template-create-modal"
            :class="{ 'is-success': showSaveSuccess }"
            :title="modalTitle"
            width="s"
        >
            {% block swag_cms_extensions_form_template_create_modal_content %}
                {% block swag_cms_extensions_form_template_create_modal_content_save_success %}
                    <template v-if="showSaveSuccess">
                        {# @deprecated tag:v6.0.0 - Block will be removed. Use `swag_cms_extensions_form_template_create_modal_content_save_success_message` instead. #}
                        {% block swag_cms_extensions_form_template_create_modal_content_save_success_bubble %}{% endblock %}

                        {% block swag_cms_extensions_form_template_create_modal_content_save_success_message %}
                            <p class="swag-cms-extensions-form-template-create-modal__message-success">
                                {{ successMessage }}
                            </p>
                        {% endblock %}
                    </template>
                {% endblock %}

                {% block swag_cms_extensions_form_template_create_modal_content_overwrite_select %}
                    <sw-entity-single-select
                        v-else-if="showOverwriteSelect"
                        :value="overwriteId"
                        @update:value="onOverwriteSelectChange"
                        :label="$tc('swag-cms-extensions.sw-cms.elements.custom-form.createTemplateModal.overwriteSelectLabel')"
                        entity="swag_cms_extensions_form"
                        labelProperty="technicalName"
                        :criteria="templateCriteria">
                    </sw-entity-single-select>
                {% endblock %}

                {% block swag_cms_extensions_form_template_create_modal_content_overwrite_confirmation %}
                    <div v-else-if="showOverwriteConfirmation"
                         class="swag-cms-extensions-form-template-create-modal__confirmation-text-container">
                        <p v-html="overwriteConfirmationText"
                           class="swag-cms-extensions-form-template-create-modal__confirmation-text">
                        </p>
                    </div>
                {% endblock %}

                {% block swag_cms_extensions_form_template_create_modal_content_default %}
                    <template v-else>
                        {% block swag_cms_extensions_form_template_create_modal_content_default_template_name %}
                            <mt-text-field
                                v-model="templateName"
                                :label="$tc('swag-cms-extensions.sw-cms.elements.custom-form.createTemplateModal.templateNameLabel')"
                                :placeholder="$tc('swag-cms-extensions.sw-cms.elements.custom-form.createTemplateModal.placeholder')"
                                @change="onTemplateNameChange"
                            >
                            </mt-text-field>
                        {% endblock %}

                        {% block swag_cms_extensions_form_template_create_modal_content_default_overwrite_warning %}
                            <mt-banner
                                v-if="showOverwriteWarning"
                                variant="attention"
                            >
                                {{ $tc('swag-cms-extensions.sw-cms.elements.custom-form.createTemplateModal.overwriteWarningText') }}
                            </mt-banner>
                        {% endblock %}

                        {% block swag_cms_extensions_form_template_create_modal_content_default_overwrite_select_link %}
                            <a v-else
                               class="swag-cms-extensions-form-template-create-modal__link"
                               @click="openOverwriteContent">
                                {{ $tc('swag-cms-extensions.sw-cms.elements.custom-form.createTemplateModal.overwriteLinkText') }}

                                <mt-icon name="regular-chevron-right-xs"/>
                            </a>
                        {% endblock %}
                    </template>
                {% endblock %}
            {% endblock %}

            {% block swag_cms_extensions_form_template_create_modal_footer %}
                <template #footer>
                    <div class="swag-cms-extensions-form-template-create-modal__footer">
                        {% block swag_cms_extensions_form_template_create_modal_footer_ghost_button %}
                            <mt-button
                                v-if="!showSaveSuccess"
                                variant="secondary"
                                @click="onModalClose"
                            >
                                {% block swag_cms_extensions_form_template_create_modal_footer_ghost_button_text %}
                                    {{ $tc('global.default.cancel') }}
                                {% endblock %}
                            </mt-button>
                        {% endblock %}

                        {% block swag_cms_extensions_form_template_create_modal_footer_primary_button %}
                            <mt-button
                                variant="primary"
                                :disabled="!templateName.length"
                                @click="onPrimaryConfirm"
                            >
                                {% block swag_cms_extensions_form_template_create_modal_footer_primary_button_text %}
                                    {{ primaryConfirmLabel }}
                                {% endblock %}
                            </mt-button>
                        {% endblock %}
                    </div>
                </template>
            {% endblock %}
        </mt-modal>
    </mt-modal-root>
{% endblock %}
